import { getAxiosInstance } from '../client';
/** Mutation functions for authentication */
export const authMutations = {
    /** POST /auth/verify-email-update/:token */
    verifyEmailUpdate: (token) => getAxiosInstance()
        .post(`/auth/verify-email-update/${token}`)
        .then((r) => r.data),
    /**
     * POST /auth/call-session — exchanges a video TAN for a call token (#1855).
     * Public: the tab holds no session yet. Every TAN that gets nobody in is a
     * 401 `TAN_INVALID`; too many failures a 429 `RATE_LIMITED`.
     */
    exchangeTan: (tan) => getAxiosInstance()
        .post('/auth/call-session', { tan }, { skipAuthToken: true })
        .then((r) => r.data),
    /**
     * POST /auth/media-session — sets the path-bound media cookie (ADR-0038).
     * The API is cross-origin, so without credentials the browser drops the
     * Set-Cookie. 403 means this session may not hold one (TAN, api key, extern).
     */
    mintMediaSession: () => getAxiosInstance()
        .post('/auth/media-session', undefined, { withCredentials: true })
        .then((r) => r.data),
    /**
     * DELETE /auth/media-session — public; logout's Clear-Site-Data spares
     * cookies. No bearer: this runs during logout, possibly one a failed token
     * refresh started, and must not wait on that refresh.
     */
    clearMediaSession: () => getAxiosInstance()
        .delete('/auth/media-session', { withCredentials: true, skipAuthToken: true })
        .then(() => undefined),
};
//# sourceMappingURL=auth.mutations.js.map